import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from './api';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      navigate('/admin');
    } catch (err: any) {
      console.error(err);
      alert(err?.error || err?.message || 'Network error');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0f172a]">
      <form onSubmit={submit} className="bg-white dark:bg-slate-800 p-6 rounded shadow-md w-full max-w-md">
        <h2 className="text-2xl font-semibold mb-4 text-slate-800 dark:text-slate-100">Admin Login</h2>
  <label className="block mb-2 text-sm text-slate-700 dark:text-slate-300">Username</label>
  <input aria-label="username" placeholder="admin" value={username} onChange={e => setUsername(e.target.value)} className="w-full p-2 border rounded mb-4" />
  <label className="block mb-2 text-sm text-slate-700 dark:text-slate-300">Password</label>
  <input aria-label="password" placeholder="••••••" value={password} onChange={e => setPassword(e.target.value)} type="password" className="w-full p-2 border rounded mb-4" />
        <button disabled={loading} className="w-full bg-sky-600 text-white py-2 rounded">
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
}
